module.exports = __webpack_public_path__ + "img/google-play-store-icon.53effd37.png";